import axios from '@/plugins/api.request'

/**
 * 赛事列表
 * @param {*} data
 */
export const list = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.UcenterMatch.List',
    data
  })
}

/**
 * 赛事详情
 * @param {*} data
 */
export const detail = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.UcenterMatch.Details',
    data
  })
}

/**
 * 获取赛事报名表
 * @param {*} data 
 */
export const getSignUpForm = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.UcenterMatch.SignUpForm',
    data
  });
}

/**
 * 赛事报名 - 提交报名信息
 * @param {*} data 
 */
export const postSignUpData = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.UcenterMatch.SignUp',
    data
  });
}

/**
 * 赛事报名 - 修改报名信息
 * @param {*} data 
 */
export const updateSignUpData = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.UcenterMatch.UpdateSignUp',
    data
  });
}

/**
 * 获取赛程已提交作品的团队
 * @param {*} data
 */
export const getUploadedTeams = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.UcenterMatch.GetUploadedTeams',
    data
  });
}

/**
 * 作品提交及修改
 * @param {*} data
 */
export const workUpload = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.UcenterMatch.WorkUpload',
    data
  });
}

/**
 * 统计信息
 * @param {*} data
 */
export const statistics = (data) => {
  return axios.request({
    method: 'post',
    url: 'v2api.php?s=Match.UcenterMatch.getUserStatistics',
    data
  });
}
